import { enqueueSnackbar } from "notistack";
import { CMDBUser, ServerAPIResponse, UserRole } from "../helpers/interfaces";
import { showBackDrop, callServerAPI, getUserEmail } from '../helpers/utils'
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);


export const getAllCMDBUsers = async () => {
    return await new Promise<CMDBUser[]>(async (resolve, reject) => {
        callServerAPI<ServerAPIResponse<CMDBUser[]>>('GET', '/api/tepng-user/get-cmdb-users', null)
            .then(response => {
                resolve(response.data.data)
            })
    })
}

export const getAllUserRoles = async () => {
    return await new Promise<UserRole[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading User Roles"));
        callServerAPI<ServerAPIResponse<UserRole[]>>('GET', '/api/tepng-user/get-user-roles', null)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export async function removeUserFromRole(userRole: UserRole) {    
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(`Removing ${getUserEmail(userRole.user_principal_id)} to ${userRole.role} Role`));
        await callServerAPI<ServerAPIResponse<any>>('DELETE', `/api/tepng-user/remove-user-from-role?role=${userRole.role}&user_principal_id=${window.encodeURIComponent(userRole.user_principal_id)}`, null)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(`${getUserEmail(userRole.user_principal_id)} removed from ${userRole.role} Role`, { variant: 'success' });
                resolve()
            })
    })
}

export async function addUserToRole(userRole: UserRole) {     
    return await new Promise<void>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(`Adding ${getUserEmail(userRole.user_principal_id)} to ${userRole.role} Role`));
        await callServerAPI<ServerAPIResponse<UserRole>>('POST', `/api/tepng-user/add-user-to-role?role=${userRole.role}&user_principal_id=${window.encodeURIComponent(userRole.user_principal_id)}`, null)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(`${getUserEmail(userRole.user_principal_id)} added to ${userRole.role} Role`, { variant: 'success' });
                resolve()
            })
    })
}
